// extracted by mini-css-extract-plugin
export var explainable = "_bw-a";
export var printerCard = "_bw-1";
export var printerCardConfigured = "_bw-2";
export var printerCardError = "_bw-3";
export var printerCardsContainer = "_bw-0";
export var printerIcon = "_bw-8";
export var printerIconConfigured = "_bw-5";
export var printerIconContainer = "_bw-4";
export var printerIconError = "_bw-6";
export var printerIconUnconfigured = "_bw-7";
export var workstationsTableCard = "_bw-9";